import { render } from "./GeneralView.vue?vue&type=template&id=32927dda&scoped=true"
import script from "./GeneralView.vue?vue&type=script&class=notranslate&lang=js"
export * from "./GeneralView.vue?vue&type=script&class=notranslate&lang=js"

import "./GeneralView.vue?vue&type=style&index=0&id=32927dda&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32927dda"]])

export default __exports__